import {
    useCallback,
} from 'react'

import useDelayedLoadOptions, {
    DelayedLoadOptions,
} from 'app/hooks/useDelayedLoadOptions'
import requests from 'app/requests/Company.requests'
import {
    Company,
} from 'app/Apps/ContactManagement/Companies/Companies.types'
import {
    IndustryType,
} from 'app/enums/label.enums'

export default (filterByIndustryType: IndustryType[] = undefined): {
    loadOptions: (options: DelayedLoadOptions) => Promise<any>,
    conversion: (c: Company[]) => {
        value: number,
        id: number,
        label: string
    }[]
} => {
    const conversion = useCallback((companies = []) => {
        return companies.map(({
            companyName, id,
        }) => {
            return {
                value: id,
                label: companyName,
                id,
            }
        })
    }, [])

    const loadOptions = useDelayedLoadOptions({
        ...requests.selector,
        ...(filterByIndustryType && {
            includeFilters: {
                industryType: filterByIndustryType,
            },
        }),
    })

    return {
        loadOptions,
        conversion,
    }
}
